import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { ifProp } from '@lib/ifProp';

interface PenLineProps extends React.SVGProps<SVGSVGElement> {
  isFullCentered?: boolean;
}

export const PenLine: React.FC<PenLineProps> = ({ isFullCentered, children, ...props }) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Wrapper isFullCentered={isFullCentered} {...props}>
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.svg<{ isFullCentered?: boolean }>`
  position: absolute;
  left: 50%;
  height: auto;
  transform: ${ifProp('isFullCentered', 'translate(-50%, -50%)', 'translateX(-50%)')};
  ${ifProp(
    'isFullCentered',
    css`
      top: 50%;
    `,
    css`
      bottom: 0;
    `,
  )}
`;
